export const NAME_SPACE = 'ASSET_VIEW';

export const DETAILS_MODE = {
	panels: 'panels',
	fullwindow: 'fullwindow'
};

export const ASSET_PANELS = {
	details: 'Asset Details',
	history: 'Asset History',
	group: 'Asset Group'
};

export const FILTER_ORDER = {
	numericAsc: 'numericAsc',
	numericDesc: 'numericDesc',
	alphaAsc: 'alphaAsc',
	alphaDesc: 'alphaDesc'
};

export const APPROVAL_MODE = {
	unapproved: 'u',
	approved: 'a',
	mixed: 'm'
};

export const MANAGER_LIST_PAGE = 200;
export const MANAGER_LIST_PAGING = 75;
export const MANAGER_PAGE_SIZES = [200, 500, 1000, 'All'];
// Elasticsearch rejects from+size past its result window (default 10000), so
// "All" and deep pages are capped there.
export const MANAGER_MAX_RESULT_WINDOW = 10000;

export const DOWNLOADING_TEXT = 'Downloading...';
